import React from 'react';
import Banner from './Banner/Banner';
import NavigationBar from './NavigationBar/NavigationBar';
import SearchSection from './SearchSection/SearchSection';
import CardSection from './CardSection/CardSection';
import SearchBar from './SearchBar/SearchBar';
import ContactForm from './ConactForm/ContactForm';
import { connect } from 'react-redux';
import './App.css';

class App extends React.Component {
  state = {
    showApp: false
  }

  render() {
    return (
      <div id ="app">
        <div id = "topHeader">
          <NavigationBar />
        { this.props.toggle.showForm 
          ? <div id='banner'> 
              <Banner /> 
            </div>
          : <ContactForm /> }
        </div>
        <div id="searchSection">
          <SearchSection />
        </div>
        <div id="cardSection">
          <SearchBar />
          <CardSection />
        </div> 
      </div>
    )
  }
}

const mapStateToProps = state => ({
	toggle: state.form
});

export default connect(mapStateToProps)(App);
